module.exports = __webpack_public_path__ + "img/big_eye_chart02.b4354e39.jpg";